type DisplayNumberOptions = {
  toFixed: number;
};

export const displayNumber = (number: number, options?: DisplayNumberOptions) => {
  const { toFixed = 1 } = options || {};
  if (isNaN(number)) {
    console.warn("Invalid number:", number);
    return 0;
  }

  if (Number.isInteger(number)) return number;

  if (toFixed !== undefined) {
    return number.toLocaleString("nl-NL", {
      minimumFractionDigits: toFixed,
      maximumFractionDigits: toFixed,
    });
  }

  return number;
};
